import React from 'react';
import {Box, Center, Container, Flex, Highlight, Image, Text} from "@chakra-ui/react";
import {Swiper, SwiperSlide} from "swiper/react";
import {EffectFade, Navigation} from "swiper";
import {HiOutlineArrowNarrowLeft, HiOutlineArrowNarrowRight} from "react-icons/hi";
import {ProcessStaticData} from "../../helpers/adminData";
const ProcessControl = () => {
    return (
        <Box className="control">
            <Container maxW="container.xl" mb="150px">
                <Flex alignItems="end"
                      flexDir={{base: "column", lg: "row"}}>
                    <Box w={{base: "full", lg: "50%"}} mb={{base:"26px",lg:"0"}}>
                        <Text  pb={{base: "20px", lg: "37px"}} fontFamily='Raleway' fontWeight="700"
                                 fontSize={{base: "30px", md: "54px"}} color="#111212"
                                 lineHeight={{base: "35px", md: "63px"}}>
                            <Highlight query={"изготовления"} styles={{color: "#E92F34"}}>Контроль изготовления отливок  </Highlight>
                        </Text>
                        <Box w="full" h="full" bg="#EEEEEE" borderRadius="20px" p={{base:"20px 14px",md:"48px 50.5px"}}>
                            <Text fontFamily='Raleway' fontWeight="400"
                                     fontSize={{base: "18px", md: "24px"}} color="#000000"
                                     lineHeight={{base: "21px", md: "28px"}}>
                                <Highlight query={`оптико-эмиссионным спектрометром.`} styles={{color: "#E92F34", whiteSpace: "normal"}}>В процессе изготовления отливок проводится промежуточный контроль химического состава отливаемого сплава оптико-эмиссионным спектрометром. </Highlight>
                            </Text>
                            <Text pt="20px" fontFamily='Raleway' fontWeight="400" fontSize={{base: "16px", md: "20px"}} color="#000000"
                                   lineHeight={{base: "19px", md: "23px"}}>после завершения термической обработки отливок производится контроль их твердости с помощью твердомера</Text>
                        </Box>
                    </Box>
                    <Box w={{base: "full", lg: "45%"}} ml="79px" bg="#FFFFFF" border="1px solid #E9ECED" borderRadius="24px"
                         boxShadow="0px 2px 4px rgba(148, 165, 168, 0.25)" px={{base: "12px", lg: "16px"}}  py={{base: "14px", lg: "21px"}}>
                            <Swiper
                                navigation={{
                                    prevEl: '#mySwiper.swiper-button-prev',
                                    nextEl: '#mySwiper.swiper-button-next'
                                }}
                                modules={[Navigation, EffectFade]}
                                className="mySwiper"
                            >
                                {ProcessStaticData.map(({process}) => (
                                    <SwiperSlide ><Image  w="full" objectFit="cover" h={{base:"280px",lg:"438px"}} borderRadius="20px" src={process} alt="img"/></SwiperSlide>
                                ))}
                                <Center fontSize="25px" color="#394A6C" id="mySwiper"
                                        className="swiper-button-prev"><HiOutlineArrowNarrowLeft/></Center>
                                <Center fontSize="25px" color="#394A6C" id="mySwiper"
                                        className="swiper-button-next"><HiOutlineArrowNarrowRight/></Center>
                            </Swiper>
                    </Box>
                </Flex>
            </Container>
        </Box>
    );
};

export default ProcessControl;
